
export class AppDetailLayout2Data {
    sidenavDisabled?: boolean;

    constructor(data?) {
        data = data || {};
        this.sidenavDisabled = data.sidenavDisabled || false;
    }
}
